import api from "services/api";

export const fetchDocumentTypes = async () => {
  const res = await api.get("/DocumentType");
  return res.data;
};

export const getDocumentTypes = async ({
  documentCategory,
  pageSize = 1000,
  pageNumber = 1,
  searchTerm,
  sortColumn,
  sortDirection = "ASC",
} = {}) => {
  const params = {
    pageSize,
    pageNumber,
    sortDirection,
  };

  if (searchTerm) params.searchTerm = searchTerm;
  if (sortColumn) params.sortColumn = sortColumn;

  const endpoint = documentCategory ? "/DocumentType/category" : "/DocumentType";
  if (documentCategory) params.documentCategory = documentCategory;

  const res = await api.get(endpoint, { params });
  return res.data;
};

export const createDocumentType = async (payload) => {
  const res = await api.post("/DocumentType", payload);
  return res.data;
};

export const updateDocumentType = async (id, payload) => {
  const res = await api.put(`/DocumentType/${id}`, payload);
  return res.data;
};

export const deleteDocumentType = async (id) => {
  const res = await api.delete(`/DocumentType/${id}`);
  return res.data;
};
